export { default } from './index.vue'



// WEBPACK FOOTER //
// ./packages/dof-step-action/index.js